export default __webpack_public_path__ + "static/media/dam.eef2834b.svg";